import { Typography, Button } from "@mui/material";
import com from "../../../UI/resources/img/PastoresIsaacAndrea.png";
import style from "./NewHere.module.css";
import platos from "../../../UI/resources/img/platos.webp";
import VideoGallery from "../../components/VideoGallery/VideoGallery";
import { useNavigate } from "react-router-dom";
import HomeIcono from "../../components/HomeIcon/HomeIcono";

const NewHere: React.FC = () => {
  // Navegación programática
  const navigate = useNavigate();

  return (
    <div className={style.newHereMain}>
      <HomeIcono></HomeIcono>
      {/*<VideoGallery></VideoGallery>*/}

      <Typography
         variant="h2"
        component="h2"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "clamp(1.8rem, 5vw, 2.8rem)",
          lineHeight: 1.2,
          fontWeight: 900,
          marginBottom: 3,
          color: "black",
        }}
        >
        ¿Nuevo aquí?
        </Typography>
        
      <div className={style.container}>
 
      <div>
          <img src={platos} className={style.imgcontainer} alt="Hands up" />
        </div>

        <div className={style.textcontainer}>

          <Typography variant="body1" component="p" style={{textAlign : "justify"}}>
          ¡Gracias por disfrutar de Colectivo Siete en este tiempo! Queremos darte la 
          bienvenida a Colectivo Siete, y como muestra de nuestro abrazo virtual, en 
          los próximos días te enviaremos un correo con acceso a varios recursos que 
          serán muy especiales para ti.
          </Typography>

          
        
        <Button
          onClick={() => navigate("/register")}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#fec93b",
            color: "black",
            marginTop: 3,
            marginBottom: 2,
            fontFamily: "Poppins, sans-serif",
            fontSize: "20px",
            fontWeight: "bold",
            borderStyle: "solid",
            borderColor: "black",
            borderWidth: "2px",
            borderRadius: "5px",

            ":hover":{
              background:"black",
              color: "#fec93b"
            }
          }}
        >
          Registrarse
        </Button>
        </div>
 

      </div>

  

      <div className={style.containerPastors}>
        <Typography
          variant="h2"
          component="h2"
          align="center"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 40,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 5,
            color: "black",
          }}
        >
          Conoce a nuestros pastores
        </Typography>

        <div className={style.meetourpastors}>
          <div className={style.imgcontainerPastors}>
            <img src={com} alt="Hands up" className={style.imgPastors} />
          </div>
          <div>
            <Typography variant="body1" component="p" style={{textAlign : "justify"}}>
            Los Pastores Andrea e Isaac Salamanca son provenientes de la CDMX, con un 
            llamado de parte de Dios desde que eran solteros. Sirvieron como pastores de 
            alabanza y jovenes en distintas congregaciones como apoyos pastorales.
            Son padres de 3 jóvenes (Andrik, Tzadik, Dana) que están involucrados al 
            100% en la obra en Colectivo. 
            El enfoque y el interés de nuestros pastores es fundar una comunidad de 
            creyentes con familias fuertes consolidadas en la Palabra del Señor.
            </Typography>
          </div>
        </div>
      </div>
      <div className={style.textcontainer}>
        <Typography
          variant="h2"
          component="h2"
          align="center"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: 45,
            lineHeight: 1.2,
            fontWeight: 900,
            marginBottom: 3,
            marginTop: 10,
            color: "black",
          }}
        >
          ¿Nuevo aquí?
        </Typography>
        <Typography variant="body1" component="p" sx={{ textAlign: "center" }}>
          ¡Te estábamos esperando! 
          En Colectivo Siete hay un lugar para ti
        </Typography>
      </div>
      <div className={style.buttoncontainer}>
        <Button
          onClick={() => navigate("/register")}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#fec93b",
            color: "black",
            marginTop: 3,
            marginBottom: 2,
            fontFamily: "Poppins, sans-serif",
            fontSize: "20px",
            fontWeight: "bold",
            borderStyle: "solid",
            borderColor: "black",
            borderWidth: "2px",
            borderRadius: "5px",

            ":hover":{
              background:"black",
              color: "#fec93b"
            }
          }}
        >
          Registrarse
        </Button>
      </div>
    </div>
  );
};

export default NewHere;
